module.exports = __webpack_public_path__ + "img/status-change.ce20d79d.png";